module.exports = __webpack_public_path__ + "img/logo-credential-issuers.904a00f7.png";